import { toast } from 'sonner';
/**
 * Cross-block signal that the learner's micro progress/favorite state
 * changed (popup completion, heart toggle). Rails/grids listen and
 * refetch {@code progress.fetchMine} so card badges + hearts stay in
 * sync without prop-drilling through the popup host — the same job
 * legacy's reload-progress-on-popup-close performed.
 */
export const MICRO_PROGRESS_UPDATED_EVENT = 'micro:progress-updated';

export function dispatchMicroProgressUpdated(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(MICRO_PROGRESS_UPDATED_EVENT));
}

/**
 * Short confirmation toast (favourite added / removed, …) through the
 * app's sonner {@code <Toaster/>} — the same surface every other portal
 * notification uses, mounted once in the root layout.
 */
export function dispatchMicroToast(
  message: string,
  opts: { description?: string; tone?: 'success' | 'neutral' } = {},
) {
  if (opts.tone === 'neutral') toast(message, { description: opts.description });
  else toast.success(message, { description: opts.description });
}
